// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"91":"8a8218f9","336":"2a778e03","366":"c95359dc","578":"6b55039a"}[chunkId] + ".chunk.css";
};